import axios from "axios";
import querystring from "querystring";
import { apiURL } from "../../../../config/config";

export const loginAPI = async (mobile_number, password) => {
  try {
    const response = await axios.post(
      `${apiURL}/api/login`,
      querystring.stringify({
        mobile_number: mobile_number,
        password: password,
      })
    );
    return response.data;
  } catch (error) {
    return {
      status_code: 502
    }
  }
};